/* LUXOR CARDS — Carrito lateral (21-oct). Sin dependencias externas.
   Si algo falla, el formulario se envía de forma normal a /cart. */
const ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
const url = (p) => ROOT + p.replace(/^\//, '');
/* BUILD: subir este número cada vez que cambie luxor-experience.css o luxor-experience.js. */
const BUILD = '7';
const ver = new URL(import.meta.url).searchParams.get('v') || '1';
const asset = (f) => { const u = new URL(f, import.meta.url); u.search = '?v=' + ver + '-' + BUILD; return u.href; };
const FREE_FROM = 2;
const SHIP_CLP = 3990;
const TARGET_FORMS = new Set(['lx-detail-form', 'lc-studio-form', 'lg-quickadd-form']);
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const onCartPage = /\/cart\/?$/.test(location.pathname);
const money = (c) => '$' + Math.round(Number(c || 0) / 100).toLocaleString('es-CL');
const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

if (!window.LuxorCart) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = asset('luxor-experience.css');
  document.head.appendChild(link);

  const overlay = document.createElement('div');
  overlay.className = 'lxd-overlay';
  const drawer = document.createElement('aside');
  drawer.className = 'lxd';
  drawer.setAttribute('role', 'dialog');
  drawer.setAttribute('aria-modal', 'true');
  drawer.setAttribute('aria-labelledby', 'lxd-title');
  drawer.setAttribute('aria-hidden', 'true');
  drawer.innerHTML = `
<div class="lxd-head"><h2 class="lxd-title" id="lxd-title">Tu selección <small class="lxd-count"></small></h2><button type="button" class="lxd-close" aria-label="Cerrar carrito">×</button></div>
<p class="lxd-flash" role="status" aria-live="polite" hidden></p>
<div class="lxd-ship"><p class="lxd-ship-msg"></p><div class="lxd-bar" aria-hidden="true"><span></span></div></div>
<div class="lxd-body"><div class="lxd-items"></div><div class="lxd-upsell" hidden><strong>¿Una segunda para regalar?</strong><span>Con 2 tarjetas el envío es gratis. Puedes elegir otro diseño y otro nombre.</span><button type="button" class="lxd-link" data-lxd="more">Elegir otro diseño →</button></div></div>
<div class="lxd-foot">
<div class="lxd-line"><span>Subtotal</span><span class="lxd-sub"></span></div>
<div class="lxd-line"><span>Envío Blue Express</span><span class="lxd-ship-cost"></span></div>
<div class="lxd-total"><span>Total estimado</span><span class="lxd-tot"></span></div>
<a class="lxd-pay" href="${url('/checkout')}">PAGAR DE FORMA SEGURA →</a>
<p class="lxd-note">Tarjeta, transferencia o cuotas débito · El envío final se confirma en el pago</p>
<button type="button" class="lxd-cont" data-lxd="close">Seguir eligiendo</button>
</div>`;
  document.body.appendChild(overlay);
  document.body.appendChild(drawer);

  const $ = (sel) => drawer.querySelector(sel);
  let isOpen = false;
  let lastFocus = null;
  const announce = () => document.dispatchEvent(new CustomEvent('luxor:drawer', { detail: { open: isOpen } }));

  function openDrawer() {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    announce();
    setTimeout(() => $('.lxd-close').focus({ preventScroll: true }), 60);
  }
  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    $('.lxd-flash').hidden = true;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    announce();
  }
  /* El aviso queda visible hasta cerrar el carrito: ocultarlo antes movería los botones bajo el dedo. */
  function flash(text) {
    const el = $('.lxd-flash');
    el.textContent = text;
    el.hidden = false;
  }
  async function getCart() {
    const r = await fetch(url('/cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!r.ok) throw new Error('cart');
    return r.json();
  }
  function thumbFor(item) {
    const ref = (item.properties || {})['Imagen de referencia'];
    if (typeof ref === 'string' && /^https:\/\/cdn\.shopify\.com\//.test(ref)) return ref;
    if (!item.image) return '';
    return item.image + (item.image.includes('?') ? '&' : '?') + 'width=220';
  }
  const HIDE = ['Diseño elegido', 'Nombre a grabar', 'Imagen de referencia', 'Texto adicional e instrucciones', 'Instrucciones'];

  function render(cart) {
    const count = cart.item_count || 0;
    const free = count >= FREE_FROM;
    $('.lxd-count').textContent = count ? '(' + count + ')' : '';
    $('.lxd-ship-msg').textContent = count === 0 ? 'Envío gratis desde 2 tarjetas'
      : free ? '✓ ¡Envío gratis desbloqueado!' : 'Te falta ' + (FREE_FROM - count) + ' tarjeta para el envío gratis';
    $('.lxd-bar span').style.width = Math.min(100, (count / FREE_FROM) * 100) + '%';
    const list = $('.lxd-items');
    if (!count) {
      list.innerHTML = '<div class="lxd-empty"><span>Tu carrito está vacío.</span><button type="button" class="lxd-pay" style="padding:0 24px;border:0;cursor:pointer" data-lxd="more">VER DISEÑOS →</button></div>';
    } else {
      list.innerHTML = cart.items.map((item) => {
        const p = item.properties || {};
        const design = p['Diseño elegido'] || item.variant_title || item.product_title;
        const name = p['Nombre a grabar'];
        const extra = Object.keys(p).filter((k) => k[0] !== '_' && !HIDE.includes(k) && String(p[k]).trim())
          .map((k) => esc(k) + ': ' + esc(p[k])).join(' · ');
        const notes = p['Texto adicional e instrucciones'] || p['Instrucciones'];
        const img = thumbFor(item);
        return `<div class="lxd-item" data-key="${esc(item.key)}">
<div class="lxd-thumb">${img ? `<img src="${esc(img)}" alt="" loading="lazy" width="92" height="92">` : ''}</div>
<div class="lxd-info">
<span class="lxd-name">${esc(design)}</span>
${name ? `<span class="lxd-meta">Nombre a grabar: <b>${esc(name)}</b></span>` : ''}
${extra ? `<span class="lxd-meta">${extra}</span>` : ''}
${notes ? `<span class="lxd-meta">Indicaciones: ${esc(String(notes).slice(0, 90))}</span>` : ''}
<div class="lxd-row">
<div class="lxd-qty"><button type="button" data-lxd="dec" aria-label="Disminuir cantidad de ${esc(design)}">−</button><span>${item.quantity}</span><button type="button" data-lxd="inc" aria-label="Aumentar cantidad de ${esc(design)}">+</button></div>
<span class="lxd-price">${money(item.final_line_price)}</span>
</div>
<button type="button" class="lxd-rm" data-lxd="rm">Eliminar</button>
</div></div>`;
      }).join('');
    }
    $('.lxd-upsell').hidden = count !== 1;
    $('.lxd-sub').textContent = money(cart.total_price);
    $('.lxd-ship-cost').textContent = count === 0 ? '—' : free ? 'GRATIS' : money(SHIP_CLP * 100);
    $('.lxd-tot').textContent = money(cart.total_price + (count > 0 && !free ? SHIP_CLP * 100 : 0));
    $('.lxd-pay').setAttribute('aria-disabled', String(count === 0));
    updateBadges(count);
  }
  function updateBadges(count) {
    document.querySelectorAll('.lxco-cart-count').forEach((b) => { b.textContent = String(count); b.hidden = count < 1; });
    const host = document.querySelector('#luxor-top .lxco-cart');
    if (host && count > 0 && !host.querySelector('.lxco-cart-count')) {
      const b = document.createElement('span');
      b.className = 'lxco-cart-count';
      b.textContent = String(count);
      host.appendChild(b);
    }
    document.querySelectorAll('cart-icon .cart-bubble__text-count, cart-icon [ref="cartBubbleCount"]').forEach((b) => { b.textContent = String(count); });
    document.querySelectorAll('cart-icon .cart-bubble').forEach((b) => b.classList.toggle('visually-hidden', count < 1));
  }
  async function refreshAndOpen() {
    openDrawer();
    drawer.classList.add('lxd-busy');
    try { render(await getCart()); } catch (e) { /* conserva el último estado */ }
    drawer.classList.remove('lxd-busy');
  }
  async function changeLine(key, quantity) {
    drawer.classList.add('lxd-busy');
    try {
      const r = await fetch(url('/cart/change.js'), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await r.json();
      if (!r.ok) throw new Error(cart.description || 'No se pudo actualizar');
      render(cart);
    } catch (e) {
      flash(e.message || 'No se pudo actualizar el carrito. Intenta nuevamente.');
    }
    drawer.classList.remove('lxd-busy');
  }
  function goToCatalog() {
    closeDrawer();
    const target = document.getElementById('luxor-modelos');
    if (target) target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    else location.href = url('/#luxor-modelos');
  }

  drawer.addEventListener('click', (e) => {
    const btn = e.target instanceof Element && e.target.closest('[data-lxd], .lxd-close');
    if (!btn) return;
    const act = btn.classList.contains('lxd-close') ? 'close' : btn.dataset.lxd;
    if (act === 'close') return closeDrawer();
    if (act === 'more') return goToCatalog();
    const line = btn.closest('.lxd-item');
    if (!line) return;
    const qty = Number(line.querySelector('.lxd-qty span').textContent) || 1;
    if (act === 'inc') changeLine(line.dataset.key, qty + 1);
    if (act === 'dec') changeLine(line.dataset.key, qty - 1);
    if (act === 'rm') changeLine(line.dataset.key, 0);
  });
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    const f = [...drawer.querySelectorAll('button, a[href]')].filter((x) => x.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Íconos de carrito: abren el carrito lateral en vez de ir a /cart. */
  window.addEventListener('click', (e) => {
    if (onCartPage || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const t = e.target instanceof Element && e.target.closest('.lxco-cart, [on\\:click="#cart-drawer/toggle"], a[href="/cart"]');
    if (!t || drawer.contains(t)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    refreshAndOpen();
  }, true);

  function formError(form, text) {
    let el = form.querySelector('.lxd-err');
    if (!el) {
      el = document.createElement('p');
      el.className = 'lxd-err';
      el.setAttribute('role', 'alert');
      const btn = form.querySelector('button[type="submit"]');
      (btn ? btn.parentNode : form).insertBefore(el, btn ? btn.nextSibling : null);
    }
    el.textContent = text;
  }

  /* "Añadir al carrito" de la ficha y del Estudio. */
  window.addEventListener('submit', async (event) => {
    const form = event.target;
    /* getAttribute: el formulario tiene un campo name="id", que oculta la propiedad form.id. */
    if (!(form instanceof HTMLFormElement) || !TARGET_FORMS.has(form.getAttribute('id')) || event.defaultPrevented) return;
    event.preventDefault();
    const button = event.submitter || form.querySelector('button[type="submit"]');
    if (button && button.dataset.lxBusy === '1') return;
    const original = button ? button.innerHTML : '';
    if (button) { button.dataset.lxBusy = '1'; button.setAttribute('aria-busy', 'true'); button.textContent = 'Agregando…'; }
    const data = new FormData(form);
    const hasFile = [...data.values()].some((v) => v instanceof File && v.size > 0);
    const design = String(data.get('properties[Diseño elegido]') || '');
    try {
      const r = await fetch(url('/cart/add.js'), {
        method: 'POST', credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      });
      const added = await r.json().catch(() => ({}));
      if (!r.ok || added.status) {
        if (hasFile && r.status >= 500) { HTMLFormElement.prototype.submit.call(form); return; }
        throw new Error(added.description || added.message || 'No pudimos añadirla. Intenta nuevamente.');
      }
      const old = form.querySelector('.lxd-err');
      if (old) old.remove();
      if (button) button.textContent = '✓ Añadida';
      const cart = await getCart().catch(() => null);
      if (cart) render(cart);
      openDrawer();
      flash('✓ Añadida a tu carrito: ' + (design || 'Luxor Card'));
    } catch (err) {
      if (hasFile && err instanceof TypeError) { HTMLFormElement.prototype.submit.call(form); return; }
      formError(form, err.message || 'No pudimos añadirla. Intenta nuevamente.');
    } finally {
      setTimeout(() => {
        if (!button) return;
        button.innerHTML = original;
        button.removeAttribute('aria-busy');
        delete button.dataset.lxBusy;
      }, 1100);
    }
  });

  window.LuxorCart = { open: refreshAndOpen, close: closeDrawer, isOpen: () => isOpen, goToCatalog };
  /* El carrito nativo del tema (Horizon) queda reemplazado: cualquier intento de abrirlo abre el lateral Luxor. */
  const nativeDrawer = document.getElementById('cart-drawer');
  if (nativeDrawer && !onCartPage) {
    nativeDrawer.open = () => { refreshAndOpen(); };
    nativeDrawer.toggle = () => { if (isOpen) closeDrawer(); else refreshAndOpen(); };
  }
  getCart().then(render).catch(() => {});
  import(asset('luxor-experience.js')).catch((e) => console.warn('[Luxor] efectos no cargados', e));
}